import util from '../util'

let controller = 'ParametrizacaoAlertaFraude'

export default Object.assign({}, util.GetCrud(controller, null), {
    Listar: function (dto, options) {
        if (options && options.data) dto.data = options.data
        return util.Axios.GetAll(controller, dto)
    },
    ListarLogs: function (dto, options) {
        if (options && options.data) dto.data = options.data
        return util.Axios.GetAll(controller + '/Logs', dto)
    }
})